<template>
  <div class="parent_div">
    <dd-header />
    <div>
      <div id="top_content">
        <div class="top_img">
          <img :src="this.getImage('top/img_hero.png')" />
          <div class="top_text">収納家具を1ミリ単位でカスタムオーダー</div>
        </div>
        <div class="top_banner">
          <img :src="this.getImage('top/HAKOTAN_banner.png')" />
        </div>
        <div class="title_text">暮らしに合わせてジャストフィットする収納家具</div>
        <div class="title_message">
          <p>ハコタンは、あなたのお部屋にピッタリの収納家具をオンラインでカスタムオーダーできます。<br>
             吊戸棚、食器棚、壁面収納など豊富なラインナップをご用意しており、<br>
             1ミリ単位でのサイズや、カラーをカスタマイズすることができます。<br>
             暮らしにジャストフィットするあなただけの快適な収納家具をお届けします。<br>
          </p>
        </div>
        <div class="step_area">
          <div class="step_content">
            <div class="step_block">
              <div class="step_first">購入までの３ステップ</div>
              <div class="step_shape">設置場所のサイズ測定</div>
              <div class="step_shape">商品を選びカスタマイズ</div>
              <div class="step_shape">ご注文を確定</div>
              </div>
          </div>
        </div>
      </div>
      <!-- メインコンテンツ -->
      <div class="main_content wrapper">
        <dd-menu ref="menuRef"/>
        <dd-content
          ref="mainContent"
        />
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'

import DDLeftMenu from '../components/top/DcLeftMenu'
import DDContent from '../components/top/DcTopContent'
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import {DC_STORAGE_KEY} from '../../constants/App'

export default {
  components: {
    'dd-menu': DDLeftMenu,
    'dd-content': DDContent,
    'dd-header': DcHeader,
    'dd-footer': DcFooter
  },
  props: {
  },
  data () {
    return {
      user: {}
    }
  },
  methods: {
    getImage: function (image) {
      return App.getYasumokuResource(image)
    }
  },
  computed: {
    isLogin: function () {
      if (!this.user || Object.keys(this.user).length <= 0) return false
      if (this.user.userId === undefined) return false
      if (this.user.userLevel === 4) return false
      return true
    }
  },
  mounted () {
  },
  created: function () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    if (this.$route.query.code) {
      let paramForm = {
        code: this.$route.query.code,
        payment: this.$route.query.payment
      }
      App.setLocalStorage(DC_STORAGE_KEY.INVITE_CODE, paramForm)
    }
    console.log(process.env.SKETCH_ORDER)
  }
}
</script>
<style src="../css/dctop.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcTop.vue